var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBooking(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.346 7a.372.372 0 00.368-.375V5.5A1.486 1.486 0 0015.245 4h-1.47V2.373A.37.37 0 0013.41 2h-1.226a.372.372 0 00-.367.374v1.625H7.9V2.374A.37.37 0 007.533 2H6.305a.372.372 0 00-.367.374v1.625H4.471A1.486 1.486 0 003.001 5.5v1.125a.372.372 0 00.366.374h12.98zM3.366 8A.372.372 0 003 8.373v8.127A1.486 1.486 0 004.471 18h10.775a1.486 1.486 0 001.47-1.5V8.372a.37.37 0 00-.367-.375L3.367 8zm10.204 3a.38.38 0 010 .53l-4.377 4.43a.361.361 0 01-.52 0l-2.53-2.605a.38.38 0 010-.53l.87-.88a.363.363 0 01.52 0l1.408 1.454 3.246-3.29a.362.362 0 01.52 0l.863.891z",
    fill: "#0D2976"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBooking);
export default ForwardRef;